// Single source of truth for which configs belong to the K9 funnel.
export const K9_FUNNEL_CONFIGS = ['customV76', 'customV78', 'customV79'];

// K9 configs with the green redesign (SF Pro, #29A073 brand, #221E1A borders).
// customV76 keeps the original purple look.
export const K9_GREEN_THEME_CONFIGS = ['customV78', 'customV79'];

// Class set on <html>; it overrides the --ed-* theme variables (see index.scss).
export const K9_GREEN_THEME_CLASS = 'k9GreenTheme';

export const isK9FunnelConfig = (config: string | null | undefined): boolean =>
  K9_FUNNEL_CONFIGS.includes(config ?? '');

export const isK9GreenThemeConfig = (config: string | null | undefined): boolean =>
  K9_GREEN_THEME_CONFIGS.includes(config ?? '');
